@if (reservationLoaded && user !== undefined && slot !== undefined) {
  <div class="wm-slotreservation-summary" attr.data-testing-id="slot-reservation-summary-{{slot.id}}"> <!-- does ignore viewtype -->
    <div class="wm-slotreservation-slot">
      <wm-slot-info [slot]="slot" [showType]="true"></wm-slot-info>
      <span class="wm-slotreservation-secondary" pTooltip="Copy Slot Id" tooltipPosition="top">
        <wm-copyable-text [displayText]="shortenedSlotId" [copyText]="slot.id"></wm-copyable-text>
      </span>
    </div>
    <div class="wm-slotreservation-time">
      @if (absReservation !== undefined) {
        @if (absoluteReservationIsOnSingleDay) {
          <div class="wm-slotreservation-primary">{{absReservation.begin | wmDateFormat:'ll'}}</div>
          <div class="wm-slotreservation-secondary">{{absReservation.begin | wmDateFormat:'LT'}} – {{absReservation.end | wmDateFormat:'LT'}}</div>
        } @else {
          <div class="wm-slotreservation-primary">{{absReservation.begin | wmDateFormat:'lll'}}</div>
          <div class="wm-slotreservation-secondary">to {{absReservation.end | wmDateFormat:'lll'}}</div>
        }
      }
      @if (schedReservation !== undefined) {
        <div class="wm-slotreservation-primary">Starts {{schedReservation.schedule.start | wmDateFormat:'lll'}}</div>
        <div class="wm-slotreservation-secondary">@if (schedReservation.until !== undefined) {Until {{schedReservation.until | wmDateFormat:'lll'}}} @else {No end date}</div>
      }
    </div>
    <div class="wm-slotreservation-duration">{{reservationDuration}}</div>
    <div class="wm-slotreservation-user">
      <wm-avatar [userId]="user.id" [noTooltip]="true"></wm-avatar>
      <div class="wm-slotreservation-user-text">
        <div class="wm-slotreservation-primary">{{user.name}}</div>
        @if (user.email) {
          <div class="wm-slotreservation-user-secondary">{{user.email}}</div>
        }
      </div>
    </div>
    <div class="wm-slotreservation-type">
      @if (schedReservation !== undefined) {
        <fa-icon icon="calendar-check" [fixedWidth]="true" [pTooltip]="'Schedule: ' + schedReservation.schedule.cronExpr" tooltipPosition="top"></fa-icon>
        <span>Recurring</span>
      }
    </div>
    @if (!isBusy) {
      <div class="wm-slotreservation-toolbar">
        <button pButton class="p-button-text" [disabled]="!mayCancelThisReserv" (click)="cancelSlotReservation()" attr.data-testing-id="slot-reservation-summary-{{slot.id}}-revokebtn">
          <fa-icon icon="ban" [fixedWidth]="true"></fa-icon><span class="wm-slotreservation-toolbar-item-label">Cancel Reservation</span>
        </button>
      </div>
    }
    @if (isBusy) {
      <div class="wm-slotreservation-toolbar-progress">
        <p-progressBar mode="indeterminate"></p-progressBar>
      </div>
    }
  </div>
}

@if (!reservationLoaded || user === undefined || slot === undefined) {
  <div class="wm-slotreservation-summary wm-slotreservation-loading"><p-progressSpinner></p-progressSpinner></div>
}
